import LocalSessionStorage from './localSession';

export default {
    __init__: [ 'localSessionStorage' ],
    localSessionStorage: [ 'type', LocalSessionStorage ]
}